import { useTranslation } from 'next-i18next';

import { useMemo } from 'react';

import { DistanceFromProps } from '@app/components/atoms/distance-from/distance-from.props';
import { DistanceTargetType } from '@app/enums/distance-target-type.enum';
import { calculateDistance, formatDistance } from '@app/helpers/distance.helpers';

/*
    It's used in ESI (multiple instanced on one page)
    We should not use Chakra until we figure out best way to include it's theme ONCE per page
*/
export const DistanceFrom = ({
    accommodationCoords,
    targetCoords,
    targetType,
    targetName,
    isNearby = false,
    translate,
    styles,
}: DistanceFromProps) => {
    const { t: translations } = useTranslation('common', {
        keyPrefix: 'distance',
    });

    const t = translate ?? translations;

    const distanceText = useMemo(() => {
        if (![DistanceTargetType.POI, DistanceTargetType.CityCenter].includes(targetType)) {
            return null;
        }

        const distanceInMeters = calculateDistance(
            accommodationCoords.lat,
            accommodationCoords.lon,
            targetCoords.lat,
            targetCoords.lon,
        );

        const formattedDistance = formatDistance(distanceInMeters);

        if (targetType === DistanceTargetType.POI) {
            return t('POI', {
                distance: formattedDistance,
                poiName: targetName,
            });
        } else if (targetType === DistanceTargetType.CityCenter) {
            if (isNearby) {
                return t('POI', { distance: formattedDistance, poiName: targetName });
            } else {
                return t('cityCenter', { distance: formattedDistance });
            }
        }
    }, [
        accommodationCoords.lat,
        accommodationCoords.lon,
        isNearby,
        t,
        targetCoords.lat,
        targetCoords.lon,
        targetName,
        targetType,
    ]);

    return distanceText ? (
        <span style={{ color: '#717171', ...styles }} data-testid={'distance-from'}>
            {distanceText}
        </span>
    ) : null;
};
